import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const FooterContainer = styled.footer`
  background-color: #ffffff;
  padding: 3rem 2rem;
  box-shadow: 0 -4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-family: 'San Francisco', sans-serif;
  color: #333;
`;

const FooterRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const Column = styled.div`
  flex: 1;
  margin: 0 2rem;

  @media (max-width: 768px) {
    margin-bottom: 2rem;
    margin: 0;
    width: 100%;
  }
`;

const ColumnTitle = styled.h3`
  font-size: 1.2rem;
  color: #007aff;
  margin-bottom: 1rem;
  font-weight: bold;
  cursor: pointer;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const ColumnLink = styled(Link)`
  display: block;
  margin-bottom: 0.5rem;
  text-decoration: none;
  color: #333;
  transition: color 0.3s ease;

  &:hover {
    color: #007aff;
  }
`;

const ExternalLink = styled.a`
  display: block;
  margin-bottom: 0.5rem;
  text-decoration: none;
  color: #333;
  transition: color 0.3s ease;

  &:hover {
    color: #007aff;
  }
`;

const ContactInfo = styled.p`
  font-size: 0.9rem;
  color: #555;
  margin-bottom: 0.5rem;
`;

const ContactPhone = styled.a`
  font-size: 0.9rem;
  color: #007aff;
  margin-bottom: 0.5rem;
  text-decoration: none;
  transition: color 0.3s ease;

  &:hover {
    text-decoration: underline;
  }
`;

const Copyright = styled.p`
  font-size: 0.9rem;
  color: #888;
  margin-top: 2rem;
`;

const MobileOnlyText = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
    text-align: center;
    font-size: 1.2rem;
    margin-bottom: 1rem;
  }
`;

const Footer = () => {
  const [openColumn, setOpenColumn] = useState(null);

  const toggleColumn = (column) => {
    setOpenColumn(openColumn === column ? null : column);
  };

  return (
    <FooterContainer>
      <FooterRow>
        <Column>
          <ColumnTitle onClick={() => toggleColumn('company')}>Компания</ColumnTitle>
          {(openColumn === 'company' || window.innerWidth > 768) && (
            <>
              <ColumnLink to="/about">О Компании</ColumnLink>
              <ColumnLink to="/news">Новости</ColumnLink>
              <ColumnLink to="/careers">Вакансии</ColumnLink>
            </>
          )}
        </Column>
        <Column>
          <ColumnTitle onClick={() => toggleColumn('customers')}>Покупателям</ColumnTitle>
          {(openColumn === 'customers' || window.innerWidth > 768) && (
            <>
              <ExternalLink href="https://sonet-dom.ru/stat/" target="_blank" rel="noopener noreferrer">Личный кабинет</ExternalLink>
              <ExternalLink href="https://sonet-dom.ru/oplata/" target="_blank" rel="noopener noreferrer">Оплатить услуги</ExternalLink>
              <ColumnLink to="/tariffs">Тарифы</ColumnLink>
            </>
          )}
        </Column>
        <Column>
          <ColumnTitle>Контакты</ColumnTitle>
          <ContactPhone href="tel:+74959941398">
             г. Солнечногорск<br />8(495)994-13-98 
          </ContactPhone>
          <ContactPhone>
             <br /> 
          </ContactPhone>
          <ContactPhone href="tel:+74962437696">
             г. Клин<br />8(49624)3-76-96
          </ContactPhone>
        </Column>
      </FooterRow>
      <Copyright>© 2002–2025 Компания ООО "Сонет-Дом".</Copyright>
    </FooterContainer>
  );
};

export default Footer;